import { DateUtil, DateWrapper } from './DateUtil'

interface Item {
  value: string
  expireAt: number
}

export class StorageUtil {
  public static set(key: string, value: string, ttl: number) {
    const item = {
      value,
      expireAt: new Date().getTime() + ttl * 1000,
    }

    localStorage.setItem(key, JSON.stringify(item))
  }

  public static get(key: string) {
    try {
      const itemStr = localStorage.getItem(key)

      if (itemStr) {
        const item: Item = JSON.parse(itemStr)

        if (this.isExpired(item.expireAt)) {
          localStorage.removeItem(key)
        } else {
          return item.value
        }
      }

      return null
    } catch {
      return null
    }
  }

  public static getAndRemove(key: string) {
    const value = this.get(key)
    this.remove(key)
    return value
  }

  public static ttl(date: string | number | Date) {
    return (new DateWrapper(date).date.getTime() - new Date().getTime()) / 1000
  }

  public static ttlExpireAtEndOfToday() {
    return this.ttl(DateUtil.endOfDay(new Date()))
  }

  public static remove(key: string) {
    localStorage.removeItem(key)
  }

  public static isExpired(expireAt: number) {
    return new Date().getTime() > expireAt
  }

  public static isExistsAndRemove(key: string) {
    return !!this.getAndRemove(key)
  }

  public static isExistsOrMarkIsExists(key: string, _ttl = 365 * 24 * 60 * 60) {
    const value = this.get(key)

    if (!value) {
      this.set(key, '1', _ttl)
    }

    return !!value
  }
}
